import { createContext } from "react";

export const RenderContext = createContext({
  isForPdfGeneration: false,
  isPuppeteerChrome: false,
});
